import { loadThemeComponent } from "@/core/config/theme-component-loader";
import { getSliderByCategory } from "@/core/lib/api/main/main-shop-product";
import { notFound } from "next/navigation";

export default async function SliderSection({ slug }: { slug: string }) {
  const slides = await getSliderByCategory(slug);
  if (!slides) notFound()
  const BannerSlider = loadThemeComponent("BannerSlider")

  return <BannerSlider slides={slides.data} varient="full" />;
}
